import React from 'react';
import { Button } from 'react-bootstrap';

import { buttonCTA } from 'components/Page/types';

function CTAButton({ text, variant, ...rest }) {
  return (
    <Button variant={variant} {...rest}>
      {text}
    </Button>
  );
}

CTAButton.defaultProps = {
  onClick: () => {},
  size: 'sm',
};

CTAButton.propTypes = buttonCTA.isRequired;

export default CTAButton;
